import React, { PropsWithChildren } from "react";
import { ViewStyle, StyleSheet, TouchableOpacity } from "react-native";
import ReactNativeModal from "react-native-modal";
import Toast from "components/toast";
import Button from "components/Button";
import ModalBar from "components/modals/ModalBar";

import { sizes, colors } from "assets/constants";

type ModalT = {
  visible?: boolean;
  close?: () => void;
  hideToast?: boolean;
  contentContainerStyle?: ViewStyle;
  disableCloseWithOutsideTap?: boolean;
  disableCloseWithBakButtonTap?: boolean;
};

const ModalInfinityList: React.FC<PropsWithChildren<ModalT>> = ({
  close,
  visible,
  children,
  hideToast,
  disableCloseWithOutsideTap,
  disableCloseWithBakButtonTap,
}) => {
  return (
    <ReactNativeModal
      isVisible={visible}
      style={{ margin: 0 }}
      animationIn={"slideInUp"}
      animationOut={"slideOutDown"}
      onBackButtonPress={!disableCloseWithBakButtonTap ? close : null}
    >
      <TouchableOpacity
        activeOpacity={1}
        style={styles.container}
        onPress={!disableCloseWithOutsideTap ? close : null}
      >
        <TouchableOpacity activeOpacity={1} style={styles.box}>
          <ModalBar />
          <Button
            onPress={close}
            square={45}
            absolute
            left={5}
            top={3}
            zIndex={2}
            icon={{ name: "x", color: colors.theme }}
            bgColor="transparent"
          />
          {children}
        </TouchableOpacity>
      </TouchableOpacity>
      {!hideToast && <Toast.Provider />}
    </ReactNativeModal>
  );
};

export default React.memo(ModalInfinityList);

const styles = StyleSheet.create({
  container: { width: "100%", height: "100%", justifyContent: "center" },

  box: {
    width: "90%",
    maxWidth: 640,
    maxHeight: "90%",
    overflow: "hidden",
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: sizes.radius.xl,
  },
});
